
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sections/[sectionSlug]",
      function () {
        return require("private-next-pages/sections/[sectionSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sections/[sectionSlug]"])
      });
    }
  